import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {DocumentDraftFile} from '../../models/draft/documentdraftfile';
import {CalendarNewsFile} from '../../models/calendar/calendarnewsfile';
const apiUrl = `${environment.apiUrl}/api/calendar/calendarnewsfile`;

@Injectable({
  providedIn: 'root'
})
export class CalendarNewsFileService {
  constructor(public httpService: HttpClient) { }
  public urlUpload: String = apiUrl + `/add/`;
  public urlDelete:  String = apiUrl + `/deletefile/`;
  public getAll(): Observable<CalendarNewsFile[]> {
    return this.httpService.get<CalendarNewsFile[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new CalendarNewsFile().deserialize(data)))
    );
  }
  public add(params: Object): Observable<CalendarNewsFile>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new CalendarNewsFile().deserialize(data)));

  }
  public update(params: Object): Observable<CalendarNewsFile>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new CalendarNewsFile().deserialize(data)));

  }
  public getCountByKeyword(keyword: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}`).pipe(
      map(data => Number(data)));
  }
  public chuyenFileTrinh(id: number, vbId: number)
  {
    return this.httpService.get(`${apiUrl}/chuyenfiletrinh?id=${id}&vbid=${vbId}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<CalendarNewsFile>
  {
    return this.httpService.get<CalendarNewsFile>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new CalendarNewsFile().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findAllByCalendarId(id: number): Observable<CalendarNewsFile[]> {
    return this.httpService.get<CalendarNewsFile[]>(`${apiUrl}/getallbycalendarid/${id}`).pipe(
      map(data => data.map(data => new CalendarNewsFile().deserialize(data)))
    );
  }
}
